import { User } from './user';

export class LoggedUser extends User {
    public IsSystemAdmin: boolean;
    public IsBUAdmin: boolean;
    public IsOrgAdmin: boolean;
}
